import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Snackbar,
  TableCell,
  TableRow,
  TextField,
  withStyles,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import React, { useEffect } from 'react';
import { MdPersonAddAlt1 } from 'react-icons/md';
import { useNavigate } from 'react-router';
import { useGrades } from '../grades/Grades';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#2490AF',
    color: theme.palette.common.white,
    fontSize: 17,
    fontFamily: 'Roboto',
  },
  body: {
    fontSize: 14,
    fontFamily: 'Roboto',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    cursor: 'pointer',
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
    maxWidth: '100%',
  },
  TableContainer: {
    maxWidth: '70%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
  },
  input: {
    marginTop: '10px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '50px',
  },
});

export function useCourses() {
  const [courses, setCourses] = React.useState([]);
  React.useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/courses')
      .then((response) => response.json())
      .then((data) => {
        setCourses(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { courses, setCourses };
}

export default function CreateCourse() {
  const classes = useStyles();
  const { courses, setCourses } = useCourses();
  const [numericName, setNumericName] = React.useState('');
  const [alphaName, setAlphaName] = React.useState('');
  const { grades } = useGrades();
  const [grade, setGrade] = React.useState('');
  const [snackCreateSuccessOpen, setSnackCreateSuccessOpen] =
    React.useState(false);
  const [snackCreateInfoOpen, setSnackCreateInfoOpen] = React.useState(false);
  const [snackErrorOpen, setSnackErrorOpen] = React.useState(false);
  const [selectedCourse, setSelectedCourse] = React.useState(null);
  const navigate = useNavigate();
  const handleSnackCreateSuccessClose = () => {
    setSnackCreateSuccessOpen(false);
  };

  const handleSnackErrorClose = () => {
    setSnackErrorOpen(false);
  };

  const handleSnackCreateInfoClose = () => {
    setSnackCreateInfoOpen(false);
  };
  const handleCreate = async () => {
    try {
      if (numericName && alphaName) {
        let response = await fetch(
          'https://api.edicionesmilenio.com/api/courses',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              numericName,
              alphaName,
              grade,
            }),
          }
        );
        let data = await response.json();
        if (data.success === true) {
          navigate('/admin/courses');
          setSnackCreateSuccessOpen(true);
        } else {
          setSnackErrorOpen(true);
        }
        setNumericName('');
        setAlphaName('');
      } else {
        setSnackCreateInfoOpen(true);
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  const handleUpdate = async (id) => {
    try {
      if (numericName && alphaName) {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/courses/${id}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              numericName,
              alphaName,
              grade,
            }),
          }
        );
        let data = await response.json();
        if (data.success === true) {
          setCourses(
            courses.map((course) => {
              if (course?._id === id) {
                return data?.data;
              }
              return course;
            })
          );
          setSnackCreateSuccessOpen(true);
        } else {
          setSnackErrorOpen(true);
        }
      } else {
        setSnackCreateInfoOpen(true);
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  const handleDelete = async (id) => {
    const choice = window.confirm(
      'Está seguro que deseas eliminar este curso?'
    );
    if (choice) {
      try {
        if (numericName && alphaName) {
          let response = await fetch(
            `https://api.edicionesmilenio.com/api/courses/${id}`,
            {
              method: 'DELETE',
            }
          );
          let data = await response.json();
          if (data.success === true) {
            setCourses(courses.filter((course) => course?._id !== id));
            //setSnackCreateSuccessOpen(true);
          } else {
            setSnackErrorOpen(true);
          }
          setNumericName('');
          setAlphaName('');
          setGrade('');
        } else {
          setSnackCreateInfoOpen(true);
        }
      } catch (error) {
        console.error(error);
        setSnackErrorOpen(true);
      }
    }
  };

  useEffect(() => {
    if (selectedCourse) {
      setNumericName(selectedCourse?.numericName);
      setAlphaName(selectedCourse?.alphaName);
      setGrade(selectedCourse?.grade?._id);
    }
  }, [selectedCourse]);
  return (
    <div className={classes.container} style={{ width: '100%' }}>
      {/* <TableContainer className={classes.TableContainer} component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Nombre Numerco</StyledTableCell>
              <StyledTableCell>Nombre Alfabetico</StyledTableCell>
              <StyledTableCell>Grado</StyledTableCell>
              <StyledTableCell>Fecha De Creación</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {courses.map((row) => (
              <StyledTableRow onClick={() => setSelectedCourse(row)} key={row._id}>
                <StyledTableCell>{row.numericName}</StyledTableCell>
                <StyledTableCell>{row.alphaName}</StyledTableCell>
                <StyledTableCell>{row.grade?.name}</StyledTableCell>
                <StyledTableCell>{row.createdAt}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}
      <form className={classes.form} noValidate autoComplete="off">
        <p className={classes.formSpan}>
          Estimado administrador, desde esta sección podrás crear un nuevo curso
          en la plataforma, siempre y cuando se cuente con la plena autorización
          de la gerencia de Ediciones Milenio, escribe a continuación el número,
          letra y selecciona el grado al que pertenece el nuevo curso, recuerda
          que debes realizar los proceso de asociación dentro de la plataforma.
        </p>
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Nombre numerico"
          variant="outlined"
          value={numericName}
          onChange={(e) => setNumericName(e.target.value)}
        />
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Numero alfabetico"
          variant="outlined"
          value={alphaName}
          onChange={(e) => setAlphaName(e.target.value)}
        />
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="demo-simple-select-outlined-label">Grado:</InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={grade}
            onChange={(e) => setGrade(e.target.value)}
            label="Grado"
          >
            {grades.map((grade) => (
              <MenuItem value={grade._id}>{grade.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={() => {
            setSelectedCourse(null);
            setNumericName('');
            setAlphaName('');
            setGrade('');
          }}
        >
          Limpiar
        </Button>
        <div className={classes.formButtonsContainer}>
          {/* <Button
            onClick={() => handleDelete(selectedCourse._id)}
            variant='contained'
            color='secondary'
          >
            <FaTrash size={15} />
            Eliminar
          </Button> */}
          {/* <Button
            onClick={() => handleUpdate(selectedCourse._id)}
            variant='contained'
          >
            <AiFillEdit size={15} />
            Actualizar
          </Button> */}
          <Button onClick={handleCreate} variant="contained" color="primary">
            <MdPersonAddAlt1 size={15} />
            Crear
          </Button>
        </div>
      </form>
      <Snackbar
        open={snackCreateSuccessOpen}
        autoHideDuration={6000}
        onClose={handleSnackCreateSuccessClose}
      >
        <Alert onClose={handleSnackCreateSuccessClose} severity="success">
          Se ha creado el curso exitosamente
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackCreateInfoOpen}
        autoHideDuration={6000}
        onClose={handleSnackCreateInfoClose}
      >
        <Alert onClose={handleSnackCreateInfoClose} severity="warning">
          Estimado administrador para crear un nuevo usuario, por favor llene
          los campos requeridos
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackErrorOpen}
        autoHideDuration={6000}
        onClose={handleSnackErrorClose}
      >
        <Alert onClose={handleSnackErrorClose} severity="error">
          Hubo un error al intentar realizar la operación, por favor intente
          nuevamente
        </Alert>
      </Snackbar>
    </div>
  );
}
